import { render } from "./EmojiOrIcon.vue?vue&type=template&id=0fc9a886&scoped=true"
import script from "./EmojiOrIcon.vue?vue&type=script&lang=js"
export * from "./EmojiOrIcon.vue?vue&type=script&lang=js"

import "./EmojiOrIcon.vue?vue&type=style&index=0&id=0fc9a886&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc9a886"]])

export default __exports__